var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tw-contents"
  }, [_c('div', [_c('label', {
    staticClass: "text-primary text-small tw-mb-2 tw-block"
  }, [_vm._v("Start Date")]), _c('b-form-datepicker', {
    staticClass: "tw-mb-1",
    attrs: {
      "min": _vm.startDateMin,
      "size": "sm"
    },
    model: {
      value: _vm.startDate,
      callback: function ($$v) {
        _vm.startDate = $$v;
      },
      expression: "startDate"
    }
  }), _c('b-form-timepicker', {
    attrs: {
      "min": _vm.startTimeMin,
      "minutes-step": "15",
      "size": "sm"
    },
    on: {
      "input": _vm.emitChange
    },
    model: {
      value: _vm.startTime,
      callback: function ($$v) {
        _vm.startTime = $$v;
      },
      expression: "startTime"
    }
  })], 1), _vm.reassignmentType === 'TEMPORARY' ? _c('div', [_c('label', {
    staticClass: "text-primary text-small tw-mb-2 tw-block"
  }, [_vm._v("End Date")]), _c('b-form-datepicker', {
    staticClass: "tw-mb-1",
    attrs: {
      "min": _vm.endDateMin,
      "size": "sm"
    },
    model: {
      value: _vm.endDate,
      callback: function ($$v) {
        _vm.endDate = $$v;
      },
      expression: "endDate"
    }
  }), _c('b-form-timepicker', {
    attrs: {
      "min": _vm.endTimeMin,
      "minutes-step": "15",
      "size": "sm"
    },
    on: {
      "input": _vm.emitChange
    },
    model: {
      value: _vm.endTime,
      callback: function ($$v) {
        _vm.endTime = $$v;
      },
      expression: "endTime"
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };